import styles from './MaterialPreviewModal.module.css';
import '../../../styles/buttons.css';
import { useIsMobile } from '../../../hooks/useIsMobile';
import { GoogleAdsAccountPickerModal } from './GoogleAdsAccountPickerModal';
import { useMaterialActions, type MaterialActionsBaseProps } from './footer/useMaterialActions';
import { useGoogleAdsAssetUpload } from './footer/useGoogleAdsAssetUpload';
import { MaterialActionsDesktop } from './footer/MaterialActionsDesktop';
import { MaterialActionsMobile } from './footer/MaterialActionsMobile';

export type MaterialPreviewFooterProps = MaterialActionsBaseProps;

/**
 * 素材プレビューモーダルのフッター。
 *
 * アクションの可視条件・活性条件・ハンドラは useMaterialActions() が単一の配列として
 * 宣言し、desktop / mobile はその配列を描画するだけ。ブレークポイントは useIsMobile()
 * (CSS の @media (max-width: 768px) と同期) で判定し、片側のみをマウントする。
 */
export function MaterialPreviewFooter(props: MaterialPreviewFooterProps) {
  const isMobile = useIsMobile();

  // Google 広告は画像素材のみ対応
  const isImageMaterial = !props.isVideo && (props.material.content_type ?? '').startsWith('image/');
  const googleAds = useGoogleAdsAssetUpload({
    materialId: props.material.id,
    isTemporaryMaterial: props.isTemporaryMaterial,
    isImageMaterial,
  });

  const actions = useMaterialActions({
    ...props,
    googleAdsTrigger: googleAds.trigger,
    googleAdsPending: googleAds.isPending,
  });

  return (
    <>
      <footer className={styles.footer}>
        {isMobile ? (
          <MaterialActionsMobile actions={actions} />
        ) : (
          <MaterialActionsDesktop actions={actions} />
        )}
      </footer>
      <GoogleAdsAccountPickerModal {...googleAds.pickerProps} />
    </>
  );
}
